import { OWN_HOME_RENT_FALLBACK } from "web_myplann/Inspiration/constants";
import type { MortgageRateBand } from "web_myplann/Inspiration/Types/MortgageRateBand";
import { computeOwnHomeContext } from "web_myplann/Inspiration/Utils/ownHomeMath";

export type OwnHomeExample = {
	rent: number;
	property: number;
};

export const getOwnHomeExample = (rates: MortgageRateBand): OwnHomeExample => {
	const context = computeOwnHomeContext(
		{ rent: OWN_HOME_RENT_FALLBACK },
		rates,
	);

	return {
		rent: OWN_HOME_RENT_FALLBACK,
		property: context.priceHigh,
	};
};
